module.exports = __webpack_public_path__ + "img/f858064.png";